export default __webpack_public_path__ + "static/media/GES_D_WHITE.ee419a7f.png";